// Module
var code = "<div class=\"image\"></div> <div class=\"block-1__caption\"> <div class=\"text\"></div> <div class=\"credits\"></div> </div> ";
// Exports
export default code;